const INTERNAL_HOST =
  /^(localhost|.*\.localhost|0\.0\.0\.0|127\.\d+\.\d+\.\d+|10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+|169\.254\.\d+\.\d+|\[::1?\]|\[f[cd][0-9a-f:]*\])$/i;

/**
 * An endpoint a visitor can actually reach, or null. A registration can name an
 * address that only means something on the server itself (`http://localhost:3051`),
 * which must not be shown as if it were a place to send requests.
 */
export function publicEndpoint(raw: string | null | undefined): string | null {
  const value = raw?.trim();
  if (!value) return null;
  try {
    const { hostname } = new URL(value.includes('://') ? value : `http://${value}`);
    return !hostname || INTERNAL_HOST.test(hostname) ? null : value;
  } catch {
    return null;
  }
}
